export default __webpack_public_path__ + "static/media/project1.2610bbcc.jpg";